
import { Link } from 'react-router-dom';

const ServicesSection = () => {
  const services = [
    {
      id: 1,
      title: '個別火葬サービス',
      description:
        '大切なペットを丁寧に個別火葬いたします。小鳥やハムスターなどの小動物から大型犬まで、すべてのペットに対応。ご家族立ち会いのもと、心を込めてお見送りいたします。',
      image:
        'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/7b0d1be53b88bd27c2a9ffffec841993.jpeg',
      link: '/services',
    },
    {
      id: 2,
      title: '納骨・永代供養',
      description:
        '合同納骨での永代供養、または個別納骨棚での3年単位のご供養をお選びいただけます。美しい納骨室で、他のペットたちと共に安らかにお眠りいただけます。',
      image:
        'https://public.readdy.ai/ai/img_res/7fe7012ce6e34319ae3db62478344bb7.jpg',
      link: '/services',
    },
    {
      id: 3,
      title: 'ペット仏具販売',
      description:
        'おりん付き祭壇、遺骨カプセル、写真立てなど、ペットを弔うための仏具を各種取り揃えております。ご自宅でゆっくりとペットを偲ぶためのアイテムをご提供いたします。',
      image:
        'https://readdy.ai/api/search-image?query=An%20elegant%20display%20of%20pet%20memorial%20items%20and%20Buddhist%20altar%20accessories%20including%20small%20bells%2C%20memorial%20capsules%2C%20photo%20frames%2C%20and%20ceremonial%20items%2C%20beautifully%20arranged%20on%20a%20clean%20surface%2C%20soft%20lighting%2C%20peaceful%20and%20respectful%20atmosphere%2C%20simple%20neutral%20background%2C%20high%20quality%20product%20photography%2C%20photorealistic%20style&width=800&height=600&seq=service-products&orientation=landscape',
      link: '/services',
    },
  ];

  return (
    <section className="py-16 sm:py-20 bg-gradient-to-b from-purple-100 to-pink-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-serif font-bold text-gray-800 mb-4">
            私たちのサービス
          </h2>
          <div className="flex justify-center">
            <i className="ri-flower-line text-purple-400 text-2xl"></i>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className="bg-white rounded-3xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2 group"
            >
              <div className="relative h-64 w-full overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-3">
                  {service.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/services"
            className="inline-flex items-center bg-purple-600 text-white px-8 py-4 rounded-full text-base font-medium hover:bg-purple-700 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            詳しく見る
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
